import { useAuth } from '../contexts/AuthContextLazy';

// Define available features and their tier requirements
type FeatureName = 
  | 'basic_documents'
  | 'basic_messaging'
  | 'portfolio_view'
  | 'realtime_portfolio'
  | 'goal_management'
  | 'tax_center'
  | 'meeting_scheduler'
  | 'client_requests_pro';

type TierLevel = 'basic' | 'pro' | 'premium';

const FEATURE_TIERS: Record<FeatureName, TierLevel> = {
  basic_documents: 'basic',
  basic_messaging: 'basic',
  portfolio_view: 'pro',
  realtime_portfolio: 'premium',
  goal_management: 'pro',
  tax_center: 'premium',
  meeting_scheduler: 'pro',
  client_requests_pro: 'pro',
};

const TIER_HIERARCHY: Record<TierLevel, number> = {
  basic: 1,
  pro: 2,
  premium: 3,
};

export const useClientFeatures = () => {
  const { organization } = useAuth();
  
  // Get the user's current tier from organization settings
  const currentTier = (organization?.subscription_tier || 'basic') as TierLevel;
  
  const hasFeature = (feature: FeatureName): boolean => {
    const requiredTier = FEATURE_TIERS[feature];
    const currentLevel = TIER_HIERARCHY[currentTier];
    const requiredLevel = TIER_HIERARCHY[requiredTier];
    
    return currentLevel >= requiredLevel;
  };
  
  const getTierInfo = () => {
    const tierDisplayNames: Record<TierLevel, string> = {
      basic: 'Basic',
      pro: 'Professional',
      premium: 'Premium'
    };
    
    return {
      tier_key: currentTier,
      display_name: tierDisplayNames[currentTier],
    };
  };
  
  return {
    hasFeature,
    currentTier,
    getTierInfo,
  };
};